import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import '../assets/sass/main.scss';
import '../assets/sass/custom.scss';

import ogImage from '../assets/images/open-graph.png';
import twitterCard from '../assets/images/twitter-card.png';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPreloaded: true,
    };
  }

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.setState({ isPreloaded: false });
    }, 100);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    const { children } = this.props;
    const { isPreloaded } = this.state;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
                description
                keywords
                url
                openGraph
                twitterCard
                twitterUsername
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                {
                  name: 'description',
                  content: data.site.siteMetadata.description,
                },
                {
                  name: 'keywords',
                  content: data.site.siteMetadata.keywords,
                },
                {
                  name: 'url',
                  content: data.site.siteMetadata.url,
                },
                {
                  name: 'og:title',
                  content: data.site.siteMetadata.title,
                },
                {
                  property: `og:description`,
                  content: data.site.siteMetadata.description,
                },
                {
                  name: 'og:type',
                  content: 'website',
                },
                {
                  name: 'og:url',
                  content: data.site.siteMetadata.url,
                },
                {
                  name: 'og:image',
                  content: `${data.site.siteMetadata.url}${ogImage}`,
                },
                {
                  name: `twitter:card`,
                  content: `summary`,
                },
                {
                  name: `twitter:title`,
                  content: data.site.siteMetadata.title,
                },
                {
                  name: `twitter:description`,
                  content: data.site.siteMetadata.description,
                },
                {
                  name: 'twitter:image',
                  content: `${data.site.siteMetadata.url}${twitterCard}`,
                },
                {
                  name: 'google-site-verification',
                  content: 'Pa_yeqIzQZm1xXBe8HRDMQpLY_z_suXP4P9I43_ppTM',
                },
              ]}
            >
              <html lang="en" />
            </Helmet>
            <div className={isPreloaded ? 'main-body is-preload' : 'main-body'}>
              {children}
            </div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
